import React, { useContext, useState } from 'react';
import {
    Box,
    Avatar,
    Typography,
    TextField,
    MenuItem,
    IconButton,
    Menu,
    MenuItem as MuiMenuItem,
    Button
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import '../../assets/styles/header.scss';
import { CommonContext } from '../../context';
import { Link, useNavigate } from 'react-router-dom';
import { AccountBalance, Calculate, CurrencyRupee, Download } from '@mui/icons-material';
import ShippingRechargeModal from '../common/ShippingRechargeModal';
import MerchantDetails from '../merchants/details/MerchantDetails';
import Logo from '../../logo.png';

const Header = ({ isSidebarCollapsed = true }) => {
    const { user, globalSearch, setGlobalSearch, walletAmount, detailsToggleDrawer } = useContext(CommonContext);
    const [anchorEl, setAnchorEl] = useState(null);
    const navigate = useNavigate();

    const handleSearch = () => {
        setGlobalSearch((prev) => ({ ...prev, searchTrigger: prev.searchTrigger + 1 }));
        if (globalSearch?.type === 'B2C') {
            navigate(`/orders/b2c`);
        } else {
            navigate(`/orders/b2b`);
        }
    };

    const handleMenuOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
    };

    const handleLogout = () => {
        localStorage.clear();
        navigate('/admin');
    };

    return (
        <>
            <MerchantDetails />
            <Box 
                className="custom-header"
                // sx={{
                //     left: isSidebarCollapsed ? '64px' : '180px',
                //     width: isSidebarCollapsed ? 'calc(100% - 64px)' : 'calc(100% - 180px)',
                //     transition: 'left 0.3s ease, width 0.3s ease'
                // }}
            >
                <Box
                    component="img"
                    src={Logo}
                    alt="Logo"
                    sx={{ width: 50, height: 50, objectFit: "contain", marginLeft: '0.5rem' }}
                />

                <Box className="header-search">
                    <Button
                        component={Link}
                        to="/download"
                        variant="outlined"
                        size="medium"
                        startIcon={<Download />}
                        sx={{
                            textTransform: 'none',
                            marginRight: '0.5rem',
                            borderColor: '#ccc',
                            color: '#fff',
                            height: '36.5px',
                            '&:hover': {
                                borderColor: '#999',
                                backgroundColor: 'rgba(0,0,0,0.03)',
                            },
                            '& .MuiButton-startIcon': {
                                marginRight: '0rem',
                            },
                        }}
                    />
                    <Button
                        component={Link}
                        to="/price-calculator"
                        variant="outlined"
                        size="medium"
                        startIcon={<Calculate />}
                        sx={{
                            textTransform: 'none',
                            marginRight: '0.5rem',
                            borderColor: '#ccc',
                            color: '#fff',
                            height: '36.5px',
                            '&:hover': {
                                borderColor: '#999',
                                backgroundColor: 'rgba(0,0,0,0.03)',
                            },
                        }}
                    >
                        Price Calculator
                    </Button>
                    {user?.user_type === "Merchant" ? (
                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                            <ShippingRechargeModal />
                            {/* <Link to='/recharge' className='recharge' style={{ textTransform: 'none', color: 'inherit', marginRight: '0.5rem' }} color="inherit" startIcon={<CurrencyRupee />}>{walletAmount?.total_balance || 0}</Link> */}
                            <Button
                                component={Link}
                                to="/recharge"
                                variant="outlined"
                                size="medium"
                                startIcon={<CurrencyRupee />}
                                sx={{
                                    textTransform: 'none',
                                    marginRight: '0.5rem',
                                    borderColor: '#ccc',
                                    color: '#fff',
                                    height: '36.5px',
                                    '&:hover': {
                                        borderColor: '#999',
                                        backgroundColor: 'rgba(0,0,0,0.03)',
                                    },
                                }}
                            >
                                {walletAmount?.total_balance || 0}
                            </Button>
                        </Box>
                    ) : (
                        <Button
                            component={Link}
                            to="/recharge"
                            variant="outlined"
                            size="medium"
                            startIcon={<AccountBalance />}
                            sx={{
                                textTransform: 'none',
                                marginRight: '0.5rem',
                                borderColor: '#ccc',
                                color: '#fff',
                                height: '36.5px',
                                '&:hover': {
                                    borderColor: '#999',
                                    backgroundColor: 'rgba(0,0,0,0.03)',
                                },
                            }}
                        >
                            Wallet
                        </Button>
                    )}

                    <Box className="search-container">
                        <TextField
                            select
                            value={globalSearch.type}
                            onChange={(e) =>
                                setGlobalSearch((prev) => ({ ...prev, type: e.target.value }))
                            }
                            variant="standard"
                            className="search-select"
                            SelectProps={{
                                disableUnderline: true,
                            }}
                        >
                            <MenuItem value="B2C">B2C</MenuItem>
                            <MenuItem value="B2B">B2B</MenuItem>
                        </TextField>

                        <TextField
                            placeholder="Search By AWB No."
                            value={globalSearch.value}
                            onChange={(e) =>
                                setGlobalSearch((prev) => ({ ...prev, value: e.target.value }))
                            }
                            variant="standard"
                            className="search-input"
                            InputProps={{
                                disableUnderline: true,
                            }}
                        />

                        <IconButton onClick={handleSearch} className="search-btn">
                            <SearchIcon />
                        </IconButton>
                    </Box>
                </Box>

                <Box className="header-right">
                    <Box className="user-info">
                        <Typography className="user-name">{user?.name}</Typography>
                        <Typography className="user-store">{user?.store}</Typography>
                    </Box>
                    <Avatar
                        onClick={handleMenuOpen}
                        sx={{ cursor: 'pointer' }}
                    >
                        {user?.name?.charAt(0) || 'N'}
                    </Avatar>

                    <Menu
                        anchorEl={anchorEl}
                        open={Boolean(anchorEl)}
                        onClose={handleMenuClose}
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'right',
                        }}
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'right',
                        }}
                    >
                        <MuiMenuItem onClick={handleLogout}>Logout</MuiMenuItem>
                        <MuiMenuItem onClick={() => { handleMenuClose(); detailsToggleDrawer(); }}>Site Setting</MuiMenuItem>
                    </Menu>
                </Box>
            </Box>
        </>
    );
};

export default Header;
